import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import OpenWithIcon from '@material-ui/icons/ZoomOutMap';
import { Casino, Replay, Undo } from '@material-ui/icons/';
import { TipsIcon } from '../Desktop';
import global from '../../../../global';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: theme.zIndex.drawer,
  },
}));

type Props = {
  onHint: () => void;
  onFullScreen: () => void;
  onUndo: () => void;
  toggleMenu: () => void;
};

export default function BottomNav({ onHint, onFullScreen, onUndo }: Props) {
  const classes = useStyles();

  return (
    <BottomNavigation id="bottom-nav" showLabels className={classes.root}>
      <BottomNavigationAction
        onClick={() => {
          global.ee.emit('new_game');
        }}
        label="Новая игра"
        icon={<Casino />}
      />
      <BottomNavigationAction
        onClick={() => {
          global.ee.emit('restart');
        }}
        label="Переиграть"
        icon={<Replay />}
      />

      <BottomNavigationAction onClick={onHint} label="Подсказка" icon={<TipsIcon />} />

      <BottomNavigationAction label="Отменить" onClick={onUndo} icon={<Undo />} />

      <BottomNavigationAction
        label={document.fullscreenElement ? 'Свернуть' : 'Развернуть'}
        icon={<OpenWithIcon />}
        onClick={onFullScreen}
      />
    </BottomNavigation>
  );
}
